var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraSlashed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15012 2.47009C4.00794 2.33761 3.8199 2.26549 3.62559 2.26892C3.43129 2.27234 3.24591 2.35106 3.1085 2.48847C2.97108 2.62588 2.89237 2.81127 2.88894 3.00557C2.88551 3.19987 2.95764 3.38792 3.09012 3.53009L21.0901 21.5301C21.1588 21.6038 21.2416 21.6629 21.3336 21.7039C21.4256 21.7449 21.5249 21.7669 21.6256 21.7687C21.7263 21.7705 21.8263 21.7519 21.9197 21.7142C22.0131 21.6765 22.0979 21.6203 22.1692 21.5491C22.2404 21.4779 22.2965 21.3931 22.3342 21.2997C22.372 21.2063 22.3905 21.1063 22.3887 21.0056C22.3869 20.9049 22.3649 20.8056 22.3239 20.7136C22.2829 20.6216 22.2238 20.5388 22.1501 20.4701L4.15012 2.47009V2.47009ZM23.1201 17.6901C23.1201 18.1611 22.9181 18.5501 22.6161 18.8141L17.8701 14.0681V7.93909L20.5601 5.25009C21.5041 4.30509 23.1201 4.97409 23.1201 6.31009V17.6901ZM16.3701 7.50009V12.5681L8.30212 4.50009H13.3701C14.1658 4.50009 14.9288 4.81616 15.4914 5.37877C16.054 5.94138 16.3701 6.70444 16.3701 7.50009ZM2.12012 7.50009C2.12012 6.71809 2.42012 6.00609 2.91012 5.47209L15.7561 18.3181C15.4765 18.6858 15.1156 18.9838 14.7017 19.1888C14.2878 19.3939 13.832 19.5004 13.3701 19.5001H5.12012C4.32447 19.5001 3.56141 19.184 2.9988 18.6214C2.43619 18.0588 2.12012 17.2957 2.12012 16.5001V7.50009Z",
    fill: "url(#paint0_linear_5719_83732)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5719_83732",
    x1: 33.6201,
    y1: 12.0188,
    x2: 14.1735,
    y2: -8.92367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05F5F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraSlashed);
export default __webpack_public_path__ + "static/media/camera-slashed.9274d0b2e3c87652d1245a3c1d8ddc8c.svg";
export { ForwardRef as ReactComponent };